import QcPageLayout from '../components/QcPageLayout';
import QcPlaceholderCard from '../components/QcPlaceholderCard';

export default function UnassignedTaskPage() {
  return (
    <QcPageLayout
      title="Un-Assigned Task"
      metaDescription="Global view of unassigned QC tasks."
      breadcrumbTitle="Un-Assigned Task"
    >
      <QcPlaceholderCard
        heading="Un-Assigned Task"
        body="All tasks that are not yet assigned will appear in this global view."
      />
    </QcPageLayout>
  );
}
